import PublicNotFound from "../scenes/notFoundPages/PublicNotFound";
import { Navigate, useLocation } from "react-router-dom";

export default function TenantRouteGuard({ children }) {
  const hasTenantToken = localStorage.getItem("tokenTenant");
  const location = useLocation();

  if (!hasTenantToken) {
    return <PublicNotFound />;
  }

  const requiresCheckout = localStorage.getItem("tenantRequiresCheckout") === "true";
  const onCheckoutPage = location.pathname === "/tenant/checkout";

  if (requiresCheckout && !onCheckoutPage) {
    return <Navigate to="/tenant/checkout" replace />;
  }

  return children;
}
